import React, {useEffect, useState} from 'react';
import {PieChart} from 'devextreme-react';
import {i18n2} from './../../../features/i18n/i18n';
import {
  Font,
  Legend,
  Series,
  Size,
  Subtitle,
  Title,
  Tooltip,
} from 'devextreme-react/pie-chart';

const pendingPalette = ['#00B050', '#D0EEA9', '#FFFF00', '#FF0000'];
const finishedPalette = ['#00B050', '#FF0000'];
const grayPalette = ['#F2F2F2'];

const PieChartPending = ({
  data = [],
  title,
  color,
  userName,
  argumentField,
  width,
  height,
  valueField,
  group,
  lookup = undefined,
  emptyMessage: emptyMessageProp,
  ...props
}) => {
  const safeData = Array.isArray(data) ? data : [];
  const [colors, setColors] = useState(grayPalette);
  const [values, setValues] = useState(safeData);
  const [hasData, setHasData] = useState(safeData.length > 0);
  const [showLegend, setShowLegend] = useState(true);

  useEffect(() => {
    const effectiveArgument = argumentField || 'title';
    const effectiveValue = valueField || 'value';
    const current = Array.isArray(data) ? data : [];
    const allZeros =
      current.length === 0 || current.every((x) => (x?.[effectiveValue] ?? 0) === 0);
    const isPlaceholder =
      current.length === 1 && current[0]?.[effectiveArgument] === 'Sin datos';
    const isEmpty = allZeros || isPlaceholder;
    const palette =
      color !== undefined
        ? color
        : title === 'pending'
        ? pendingPalette
        : finishedPalette;

    if (isEmpty) {
      const noData = {};
      noData[effectiveArgument] = '';
      noData[effectiveValue] = 0;

      setValues([noData]);
      setColors(grayPalette);
    } else {
      setValues(current);
      setColors(palette);
    }

    setHasData(!isEmpty);
    setShowLegend(!isEmpty);
  }, [argumentField, color, data, title, valueField]);

  const emptyMessage = () => {
    if (emptyMessageProp) return emptyMessageProp;
    if (title === 'pending')
      return 'No hay cursos pendientes para los filtros seleccionados.';
    if (title === 'finished')
      return 'No hay cursos finalizados para los filtros seleccionados.';
    return 'No hay datos para los filtros seleccionados.';
  };

  return (
    <div style={{position: 'relative'}}>
      <PieChart
        className="pie"
        dataSource={values}
        palette={colors}
        sizeGroup={group}
        theme="generic.dark"
        adaptiveLayout={{height: 0, width: 0}}
        {...props}>
        {title && (
          <Title text={i18n2._(title)}>
            <Font color="black" />
            <Subtitle text={userName}>
              <Font color="black" />
            </Subtitle>
          </Title>
        )}

        <Series id="series" argumentField={argumentField} valueField={valueField}></Series>
        <Tooltip target="#series" enabled={true} closeOnOutsideClick={false} color="white">
          <Font color="black" size={16} />
        </Tooltip>

        <Legend
          visible={showLegend}
          horizontalAlignment="center"
          verticalAlignment="bottom"
          orientation="horizontal"
          itemTextPosition="right"
          customizeText={(x) => {
            return lookup
              ? i18n2._(lookup(x.pointName))
              : x.pointName
              ? i18n2._(x.pointName)
              : '';
          }}>
          <Font size={14} color="black" />
        </Legend>

        <Size width={width} height={height} />
      </PieChart>
      {!hasData && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 8,
            textAlign: 'center',
            color: '#666',
            pointerEvents: 'none',
          }}>
          {emptyMessage()}
        </div>
      )}
    </div>
  );
};

export default PieChartPending;
